"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridSelectionSubheader = void 0;
const react_1 = __importDefault(require("react"));
const GridSelectionSubheader_styles_1 = require("./GridSelectionSubheader.styles");
function GridSelectionSubheader({ selected, total, texts }) {
    var _a, _b;
    return (react_1.default.createElement(GridSelectionSubheader_styles_1.StyledGridSelectionSubheader, { "data-selector-id": "grid-core-selection-subheader", className: "vm-GridSelectionSubheader" }, (_a = texts === null || texts === void 0 ? void 0 : texts.selected) !== null && _a !== void 0 ? _a : 'Selected:',
        react_1.default.createElement(GridSelectionSubheader_styles_1.StyledGridSelectionSubheaderValue, { className: "vm-GridSelectionSubheaderValue" },
            react_1.default.createElement(GridSelectionSubheader_styles_1.StyledGridSelectionSubheaderValueHighlighted, { selected: !!selected }, selected || 0),
            ' ', (_b = texts === null || texts === void 0 ? void 0 : texts.of) !== null && _b !== void 0 ? _b : 'of',
            " ",
            total || 0)));
}
exports.GridSelectionSubheader = GridSelectionSubheader;
//# sourceMappingURL=GridSelectionSubheader.js.map